import { TextField, styled } from "@mui/material";

export const PasswordEntryField = styled(TextField)`
  margin-top: 6px;
`;
